// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var NotificationsController = function ($scope, $routeParams, Notifications) {
    $scope.filter = {
        acknowledgementStatus: $routeParams.acknowledgementStatus,
        type: $routeParams.type,
        merchant: $routeParams.merchant,
    };
    setDefaultPeriod();

    $scope.loadNotifications = function () {
        setPeriodFilterDefaults();

        $scope.notifications = $scope.paginator(function (options, callback) {
                return Notifications.queryNotifications(options, callback);
            },
            {
                before: $scope.filter.before,
                after: $scope.filter.after,
                notificationType: $scope.filter.type,
                isNotificationHandled: isNotificationHandled(),
                merchant: $scope.filter.merchant
            },
            50);
    };

    $scope.acknowledgeByFilter = function () {
        setPeriodFilterDefaults();

        Notifications.acknowledge({
            before: $scope.filter.before,
            after: $scope.filter.after,
            notificationType: $scope.filter.type,
            isNotificationHandled: isNotificationHandled(),
            merchant: $scope.filter.merchant
        });

        setTimeout(function () {
            $scope.loadNotifications();
        }, 200);
    }

    $scope.acknowledgeById = function (notificationId) {
        Notifications.acknowledge({
            id: notificationId
        });

        setTimeout(function () {
            $scope.loadNotifications();
        }, 200);
    }

    $scope.loadNotifications();

    function setDefaultPeriod() {
        $scope.filter.after = moment().subtract(1, 'hours').toISOString(true);
        $scope.filter.before = moment().toISOString(true);
    }

    function getBeforeFromAfter(after) {
        return moment(after).add(1, 'hours').toISOString(true);
    }

    function getAfterFromBefore(before) {
        return moment(before).subtract(1, 'hours').toISOString(true);
    }

    function getISODateOrDefault(date) {
        return moment(date).isValid() ? moment(date).toISOString(true) : moment().toISOString(true);
    }

    function setPeriodFilterDefaults() {
        if (!moment($scope.filter.after).isValid() && !moment($scope.filter.before).isValid()) {
            setDefaultPeriod();
        } else if (moment($scope.filter.after).isValid() && !moment($scope.filter.before).isValid()) {
            $scope.filter.after = getISODateOrDefault($scope.filter.after);
            $scope.filter.before = getBeforeFromAfter($scope.filter.after);
        } else if (!moment($scope.filter.after).isValid() && moment($scope.filter.before).isValid()) {
            $scope.filter.before = getISODateOrDefault($scope.filter.before);
            $scope.filter.after = getAfterFromBefore($scope.filter.before);
        } else {
            $scope.filter.after = moment($scope.filter.after).toISOString(true);
            $scope.filter.before = moment($scope.filter.before).toISOString(true);
        }
    }

    function isNotificationHandled() {
        switch ($scope.filter.acknowledgementStatus) {
            case "New":
                return false;
            case "Acknowledged":
                return true;
            default:
                return null;
        }
    }
};
NotificationsController.$inject = ['$scope', '$routeParams', 'Logs'];
